import { Tile, Empty } from "./Tile";
import { ago } from "../../lib/dash";

const STAGES = [
  ["render", "Render"], ["views", "Views"], ["views_review", "Views review"], ["sculpt", "Sculpt"], ["waiting", "Waiting"],
  ["paint_3mf", "Paint / 3MF"],
];

export const DucksTile = ({ ducks, tone, index }) => (
  <Tile id="ducks" index={index} tone={tone} kicker="Tile 4 · in process" title="Ducks in process">
    <div className="grid grid-cols-3 gap-1.5 xl:grid-cols-6">
      {STAGES.map(([key, label]) => (
        <div key={key} className="rounded-xl bg-muted/50 px-2.5 py-1.5">
          <p className="truncate text-[11px] text-muted-foreground">{label}</p>
          <p data-testid={`ducks-${key}`} className="font-heading text-lg font-bold tabular-nums">{ducks.counts[key]}</p>
        </div>
      ))}
    </div>
    <p className="mb-1 mt-3 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
      Stuck · no progress for {ducks.stuck_minutes}+ min
    </p>
    {ducks.stuck.length === 0 ? (
      <Empty testid="ducks-stuck-none">No duck is stuck.</Empty>
    ) : (
      <ul data-testid="ducks-stuck" className="min-h-0 flex-1 overflow-y-auto pr-1">
        {ducks.stuck.map((d) => (
          <li key={d.id} className="flex items-baseline justify-between gap-2 border-b border-border/60 py-1.5 text-[13px] last:border-0">
            <span className="truncate font-medium">{d.name || "Unnamed duck"} <span className="font-mono2 text-[11px] text-muted-foreground">{d.id.slice(0, 8)}</span></span>
            <span className="shrink-0 text-rose-600">{d.build_status} · {ago(d.build_updated_at)}</span>
          </li>
        ))}
      </ul>
    )}
  </Tile>
);
